import { withList } from '../../../context/List'

import Status from './Status'
import SourceType from './SourceType'
import Delete from './Delete'

function ControlsWrapper( props ) {
  const {
    client
  } = props

  const {
    isToggled
  } = props.withList

  if ( ! isToggled )
    return <></>

  return <>
    <Delete
      client={ client }
    />

    <Status
      client={ client }
    />

    <SourceType
      client={ client }
    />
  </>
}

export default withList( ControlsWrapper )
